import React, { useState, useEffect } from 'react';
import API from '../utils/api';

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    API.get('/reviews/all')
      .then(r => { if (r.data.success) setReviews(r.data.data); })
      .catch(() => { })
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const toggle = async (id) => {
    const r = await API.patch(`/reviews/${id}/toggle`);
    if (r.data.success) setReviews(prev => prev.map(rv => rv._id === id ? r.data.data : rv));
  };

  const del = async (id) => {
    if (!window.confirm('Delete this review?')) return;
    await API.delete(`/reviews/${id}`);
    setReviews(prev => prev.filter(rv => rv._id !== id));
  };

  const stars = (n) => '★'.repeat(n) + '☆'.repeat(5 - n);
  const fmt = (d) => new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <div>
          <h2 className="admin-page__title">Customer Reviews</h2>
          <p className="admin-page__sub">{reviews.length} total · {reviews.filter(r => r.approved).length} approved</p>
        </div>
        <button className="admin-btn admin-btn--outline" onClick={load}>↺ Refresh</button>
      </div>

      {loading ? <div className="admin-loading">Loading…</div>
        : reviews.length === 0 ? <div className="admin-empty">No reviews yet.</div>
          : (
            <div className="admin-cards">
              {reviews.map(r => (
                <div key={r._id} className={`admin-review-card${!r.approved ? ' admin-review-card--hidden' : ''}`}>
                  <div className="admin-review-card__top">
                    <div>
                      <div className="admin-review-card__stars" style={{ color: r.approved ? '#8B3A62' : '#ccc' }}>{stars(r.rating)}</div>
                      <div className="admin-review-card__name">{r.name} <span className="admin-review-card__role">{r.role}</span></div>
                      <div className="admin-review-card__date">{fmt(r.createdAt)}</div>
                    </div>
                    <span className={`admin-badge ${r.approved ? 'admin-badge--green' : 'admin-badge--grey'}`}>
                      {r.approved ? 'Visible' : 'Hidden'}
                    </span>
                  </div>
                  <p className="admin-review-card__text">"{r.text}"</p>
                  <div className="admin-review-card__actions">
                    <button className="admin-btn admin-btn--outline admin-btn--sm" onClick={() => toggle(r._id)}>
                      {r.approved ? 'Hide' : 'Show'}
                    </button>
                    <button className="admin-btn admin-btn--danger admin-btn--sm" onClick={() => del(r._id)}>Delete</button>
                  </div>
                </div>
              ))}
            </div>
          )}
    </div>
  );
}
